function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_363",
  "data-name": "Group 363",
  transform: "translate(1.413 -11.722)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_19",
  "data-name": "Line 19",
  y2: 20,
  transform: "translate(6.441 12.722)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_399",
  "data-name": "Path 399",
  d: "M-171.339-182.971l6.451,6.012,6.386-6.012",
  transform: "translate(171.339 211.01)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2.5
}));

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.664,
    height: 23.699,
    viewBox: "0 0 15.664 23.699",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowRight.43352653.svg";
export { ForwardRef as ReactComponent };